import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18.345 11.47a.75.75 0 0 1 1.06 0l2.5 2.5a.754.754 0 0 1 .22.53l-.004-.074c.002.015.003.03.003.046l.001.028a.763.763 0 0 1-.129.42.748.748 0 0 1-.09.11l.068-.078a.75.75 0 0 1-.005.006l-.064.072-2.5 2.5a.75.75 0 0 1-1.06-1.06l1.219-1.22H10.75a.75.75 0 0 1-.743-.648L10 14.5a.75.75 0 0 1 .75-.75h8.814l-1.22-1.22a.75.75 0 0 1-.072-.976zm-13.75-5a.75.75 0 0 1 1.06 1.06l-1.22 1.22h8.815a.75.75 0 0 1 .743.648L14 9.5a.75.75 0 0 1-.75.75H4.435l1.22 1.22a.75.75 0 0 1 .073.976l-.073.084a.75.75 0 0 1-1.06 0l-2.5-2.5-.064-.072a.753.753 0 0 1-.156-.458l.004.077a.754.754 0 0 1-.004-.06V9.5a.765.765 0 0 1 .129-.42.748.748 0 0 1 .09-.11l-.068.078a.754.754 0 0 1 .069-.078z' />
  </svg>
);
